import { chains } from 'src/assets/data/chains';

export const truncate = (value: string, head = 8, tail = 6) =>
  value && value.length > head + tail + 3
    ? `${value.slice(0, head)}...${value.slice(-tail)}`
    : value || '-';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = (value: string) => UUID_REGEX.test(value);

// True when the submitted-tx hash is a real on-chain hash and should link to
// the block explorer. Trust the server flag when present; fall back to a UUID
// shape check only when the flag is absent (engine-credit settle path stores a
// UUID instead of a chain hash).
export const isSubmittedTxOnchain = (record: any) => {
  if (typeof record.submittedTxIsOnchain === 'boolean') {
    return record.submittedTxIsOnchain;
  }
  return !isUuid(record.submittedTxHash);
};

export const explorerTxUrl = (chainId: number, txHash: string) => {
  if (!txHash) return '';
  const match = chains.find((c) => c.id === chainId);
  return match ? `${match.browser}${txHash}` : '';
};

export const chainSymbol = (chainId: number) => {
  const match = chains.find((c) => c.id === chainId);
  return match ? match.symbol : String(chainId);
};

export const statusColor = (status: string) => {
  switch (status) {
    case 'SUCCESS':
      return 'success';
    case 'FAILED':
      return 'error';
    case 'PENDING':
      return 'default';
    case 'PROCESSING':
    case 'CONFIRMING':
      return 'info';
    default:
      return 'default';
  }
};
